import type { Course } from '@/types/domain'
import { cn } from '@/lib/utils'

type CourseArtworkProps = {
  course: Pick<Course, 'name' | 'image_url' | 'color'>
  className?: string
  imageClassName?: string
  labelClassName?: string
}

function getInitials(name: string) {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('')
}

export function CourseArtwork({
  course,
  className,
  imageClassName,
  labelClassName,
}: CourseArtworkProps) {
  if (course.image_url) {
    return (
      <div className={cn('overflow-hidden bg-muted', className)}>
        <img
          src={course.image_url}
          alt={course.name}
          className={cn('h-full w-full object-cover', imageClassName)}
        />
      </div>
    )
  }

  return (
    <div
      className={cn(
        'flex items-end overflow-hidden bg-slate-900 p-5 text-white',
        className,
      )}
      style={{
        backgroundImage: `linear-gradient(135deg, ${course.color} 0%, ${course.color} 35%, #111827 100%)`,
      }}
    >
      <div className="space-y-2">
        <div className="text-3xl font-semibold tracking-tight text-white/90">
          {getInitials(course.name)}
        </div>
        <p className={cn('max-w-[18rem] text-sm text-white/80', labelClassName)}>{course.name}</p>
      </div>
    </div>
  )
}
